export default __webpack_public_path__ + "2add96a187e83b18fe2a57e78a91b1fa0e28e61d067a3d5d0242beea59ce5a4e.svg";